"use client"
import Image from "next/image"
import React, { useEffect } from "react"

import { handleGoogleLogin, handleLogin, handleMicrosoftLogin } from "lib/actions/auth"
import { VIEW_TYPES } from "modules/analytics"
import LogoImage from "public/images/Biglogo.svg"
import GoogleLogoImage from "public/images/google.svg"
import MicrosoftLogoImage from "public/images/microsoft.svg"
import ScalerLogoImage from "public/images/scalerLogo.svg"
import analytics from "utils/analytics"
import { LOGIN_PAGE_TRACKING_EVENTS } from "utils/trackingConstants"
import styles from "./login.module.scss"

export default function Page() {
  useEffect(() => {
    analytics?.view({
      view_name: LOGIN_PAGE_TRACKING_EVENTS.viewLoginPage,
      view_type: VIEW_TYPES.dashboard,
      view_feature: LOGIN_PAGE_TRACKING_EVENTS.feature,
      view_source: LOGIN_PAGE_TRACKING_EVENTS.source,
    })
  }, [])

  return (
    <main className={styles.loginPage}>
      <div className={styles.firstSection}>
        <div className={styles.headingSection}>
          <div className={styles.headingText}>
            <div className={styles.heading}>
              <span>Sign In for </span>
              <span className={styles.scalerText}>Scaler Companion</span>
            </div>
            <span className={styles.subHeading}>Designed to boost your learning outcomes</span>
          </div>

          <button onClick={handleLogin} className={styles.buttonCompanion}>
            <Image src={ScalerLogoImage} alt="Scaler Companion" className={styles.scalerLogo} />
            <span className={styles.loginText}>Login with Scaler</span>
          </button>
          <button onClick={handleMicrosoftLogin} className={styles.buttonCompanion}>
            <Image src={MicrosoftLogoImage} alt="Microsoft" className={styles.microsoftLogo} />
            <span className={styles.loginText}>Login with Microsoft</span>
          </button>
          <button onClick={handleGoogleLogin} className={styles.buttonCompanion}>
            <Image src={GoogleLogoImage} alt="Google" className={styles.googleLogo} />
            <span className={styles.loginText}>Login with Google</span>
          </button>
        </div>
        <span className={styles.footerText}>Made with ❤️ by Scaler</span>
      </div>
      <div className={styles.secondSection}>
        <div className={styles.gridContainer}>
          {Array.from({ length: 800 }).map((_, index) => (
            <div key={index} className={styles.gridCell} />
          ))}
          <div className={styles.mask} />
        </div>
        <div className={styles.bottomMask} />

        <div className={styles.content}>
          <div className={styles.headingContainer}>
            <span className={styles.contentHeading}>Scaler Companion</span>
          </div>

          <Image src={LogoImage} alt="Scaler Companion" className={styles.logoImage} />
        </div>
      </div>
    </main>
  )
}
